import React from 'react';

const PROOF_POINTS = [
  { label: '1:1 Reserves', copy: 'Backed by reserves at licensed UAE banks' },
  { label: 'Attested monthly', copy: 'Reserve attestation by a licensed CPA' },
  { label: 'Yours to hold', copy: 'No freeze, blacklist or pause function in the contract' },
];

export const ProofStrip = () => {
  return (
    <ul className="proof-strip" aria-label="Why USDN">
      {PROOF_POINTS.map(point => (
        <li key={point.label} className="proof-tile">
          <span className="proof-label">{point.label}</span>
          <span className="proof-copy">{point.copy}</span>
        </li>
      ))}
    </ul>
  );
};
